import axios from 'axios'
import router from '../../router'
const state = {
  mBannerList: [],
  bannerRtn: ''
}

const getters = {
  getBannerList (state) {
    return state.mBannerList
  },
  getTranBanner (state) {
    return state.bannerRtn
  }
}

const mutations = {
  setBannerList (state, payload) {
    state.mBannerList = payload
  },
  setTranBanner (state, payload) {
    state.bannerRtn = payload
  }
}

const actions = {
  apiBannerList (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      axios.post('/api/admin/getBannerSearch', payload)
        .then((response) => {
          // console.log(response.data)
          context.commit('setBannerList', response.data)
          if (response.data.length > 0) {
            // context.commit('setRecommandItem', response.data)
          } else {
            alert('검색 값이 존재하지 않습니다.')
          }
        })
        .catch((error) => {
          if (error.response.status === 403) {
            sessionStorage.removeItem('token')
            alert('세션 만료 또는 잘못된 접근 입니다.')
            router.replace('/AdminLogin')
          }
        })
    }
  },
  apiTranBanner (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      return new Promise((resolve, reject) => {
        axios.post('/api/admin/tranBannerList', payload)
          .then((response) => {
            // console.log('apiTran = ' + response.data)
            context.commit('setTranBanner', response.data)
            resolve()
          })
          .catch((error) => {
            reject(error.response.data.message)
            if (error.response.status === 403) {
              sessionStorage.removeItem('token')
              alert('세션 만료 또는 잘못된 접근 입니다.')
              router.replace('/AdminLogin')
            }
            // alert(error.response.data.message)
          })
      })
    }
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/bannermanagement.js